export default __webpack_public_path__ + "a71dafba1e544ce414669ae25759a6d7.webp";